import React from 'react';
import Table from '../../components/common/Table';
import { convertToUserTime } from '../../utils/convertToUserTime';

interface NotesTableProps {
  data: any[];
  handleDelete: (service: any) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const NotesTable: React.FC<NotesTableProps> = ({
  data,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Text',
          key: 'text',
        },
        {
          label: 'Created On',
          key: 'createdUtc',
          render: (note) => <>{convertToUserTime(note.createdUtc)}</>,
        },
        {
          label: 'Status',
          key: 'status',
          render: (note) => {
            let status = '';
            let badgeColor = 'bg-gray-300 text-gray-800';

            if (note.status) {
              status = 'Saved';
              badgeColor = 'bg-green-100 text-green-800';
            } else {
              status = 'Not Saved'
              badgeColor = 'bg-red-100 text-red-800';
            }
            return <span className={`px-2 py-1 rounded text-xs font-medium ${badgeColor}`}>{status}</span>;
          },
        },
      ]}
      data={data}
      actions={{
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default NotesTable;
